import { getGroup, GetGroupResponse, getGroups, BaseApiRequest, insertGroup, updateGroup, SaveGroupResponse } from "@robe/core-api";
import { Group, PermissionsGroup } from "@robe/core-types";
import { XcoreCore } from ".";

export class XcoreGroupsPermissions {
  private core: XcoreCore;

  public constructor(core: XcoreCore) {
    this.core = core;
  }

  public list(): BaseApiRequest<Group[]> {
    return getGroups(this.core);
  }

  public single(name: string): BaseApiRequest<GetGroupResponse> {
    return getGroup(name, this.core);
  }

  public insert(group: Group, permissions: PermissionsGroup[]): BaseApiRequest<SaveGroupResponse> {
    return insertGroup(group, permissions, this.core);
  }

  public update(group: Group, permissions: PermissionsGroup[]): BaseApiRequest<SaveGroupResponse> {
    return updateGroup(group, permissions, this.core);
  }
}
